import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-curtain', 'showLess', 'Näita vähem');
Labels.set('ui-curtain', 'showMore', 'Näita rohkem');
Labels.set('ui-curtain', 'completedStep', 'Samm täidetud');
